import { render, staticRenderFns } from "./ItemModify.vue?vue&type=template&id=7cb31634&scoped=true"
import script from "./ItemModify.vue?vue&type=script&lang=ts"
export * from "./ItemModify.vue?vue&type=script&lang=ts"
import style0 from "./ItemModify.vue?vue&type=style&index=0&id=7cb31634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb31634",
  null
  
)

export default component.exports